import React, { useMemo } from "react";
import { getCustomFlowAnswerVariables } from "./flowVariableCatalog";

/**
 * Dropdown of answer variables from this chatbot flow (Question / Form nodes only).
 */
export default function FlowAnswerVariableSelect({
  value = "",
  onChange,
  customVariables = [],
  placeholder = "Pick from flow",
  disabled = false,
  style = {},
}) {
  const options = useMemo(
    () => getCustomFlowAnswerVariables(customVariables),
    [customVariables],
  );

  if (!options.length) {
    return null;
  }

  return (
    <select
      value={value || ""}
      onChange={(event) => onChange?.(event.target.value)}
      disabled={disabled}
      style={{
        minWidth: 148,
        padding: "8px 10px",
        borderRadius: 6,
        border: "1px solid #cbd5e1",
        fontSize: 13,
        background: disabled ? "#f1f5f9" : "#fff",
        ...style,
      }}
    >
      <option value="">{placeholder}</option>
      {options.map((variable) => (
        <option key={variable.id} value={variable.id}>
          {variable.id}
        </option>
      ))}
    </select>
  );
}
